import { render } from "./EmptyRequestsDialogsPlaceholder.vue?vue&type=template&id=584c170a&scoped=true"
const script = {}

import "./EmptyRequestsDialogsPlaceholder.vue?vue&type=style&index=0&id=584c170a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584c170a"]])

export default __exports__